import { createIcon } from '@chakra-ui/react'

export const KeepKeyIcon = createIcon({
  displayName: 'KeepKeyIcon',
  path: (
    <path
      d='M20.625 0A9.375 9.375 0 0 1 30 9.375v11.25A9.375 9.375 0 0 1 20.625 30H9.375A9.375 9.375 0 0 1 0 20.625V9.375A9.375 9.375 0 0 1 9 .007v23.981h2.753v-7.897L19.94 24H24l-8.788-8.198 7.976-6.848H19.27l-7.517 6.623L11.752 0h8.873Z'
      fill='currentColor'
      fillRule='evenodd'
    />
  ),
  viewBox: '0 0 30 30',
})
